//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    loadRelation,
    submitOrderSuccess
} from "@/assets/api/dataBase.js";
import {
    utils
} from "@/assets/utils/utils.js";
import axios from 'axios'
export default {
    data() {
        return {
            linkPeopleList:[],
            fbTitle: '',
            fbMessage: '',
            editAgain: '' ,
            productCode:""
        };
    },

    mounted() {
        this.getloadRelation();
    },
    filters: {
        nullFilters(value) {
            return value ? value : "--";
        },
        relationTypeFilter(val){
            if(val == '1'){
                return val = '共同借款人'
            }else if(val == '2'){
                return val = '担保人'
            }else if(val == '3'){
                return val = '其他'
            }else{
                return '--'
            }
        },
         relationTypeFilter2(val){
            if(val == '4'){
                return val = '借款申请主体法定代表人'
            }else if(val == '5'){
                return val = '借款申请主体实际控制人'
            }else if(val == '6'){
                return val = '个人保证担保人'
            }else if(val == '7'){
                return val = '个人抵押担保人'
            }else if(val == '8'){
                return val = '个人保证担保人配偶'
            }else if(val == '9'){
                return val = '个人抵押担保人配偶'
            }else if(val == '10'){
                return val = '其他'
            }else{
                return '--'
            }
    
        },
        identityFilter(val){
            if(val == '1'){
                return val = '配偶'
            }else if(val == '2'){
                return val = '朋友'
            }else if(val == '7'){
                return val = '朋友配偶'
            }else if(val == '3'){
                return val = '亲戚'
            }else if(val == '8'){
                return val = '亲戚配偶'
            }else if(val == '4'){
                return val = '其他'
            }else if(val == '5'){
                return val = '合伙人'
            }else if(val == '6'){
                return val = '合伙人配偶'
            }else{
                return '--'
            }
        }
    },
    methods: {
        
        getloadRelation() {
             let url =  process.env.BASE_API2 +'getProductCode'
            axios({
                method: 'post',
                url: url,
                data: {}
            }).then((res)=>{
                 if(res.data.responseCode === '000000'){
                    this.productCode = res.data.responseData.productCode;
                    localStorage.setItem('productCode',this.productCode)
                 }
              
            })
            loadRelation({}).then(result => {
                if (result.responseCode === "000000") {
                    let retsult = result.responseData
                    this.linkPeopleList = retsult.relationList
                }
            });
        },
        // 确定
        updateStatus() {
            submitOrderSuccess({}).then(result => {
                if (result.responseCode === "000000") {
                    let fbCode = result.responseData.fbCode
                    let loanOrderCode = result.responseData.loanOrderCode
                    let fbMessage = result.responseData.fbMessage
                    let messageInfo = utils.routerJump.returnUrl(fbCode);
                    let url = messageInfo.url
                    this.$router.push({
                        path:url,
                        query:{           
                            code:fbCode,
                            loanOrderCode:loanOrderCode,
                            fbMessage:fbMessage,
                        }
                    })
                }
            });
        },
        // 上一步
        testDemo() {
            if(this.$route.query.editAgain=='edit'){
                this.$router.push({
                    path:"/editPerson"
                });
            }else{
                this.$router.push({
                    path:"/linkPeople"
                });
            }
        },
    }
};



// WEBPACK FOOTER //
// ./src/view/informationConfirmed.vue